import { render, staticRenderFns } from "./express.vue?vue&type=template&id=e4393ed2&scoped=true&"
import script from "./express.vue?vue&type=script&lang=js&"
export * from "./express.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4393ed2",
  null
  
)

export default component.exports